import { DirectDebitState } from "@/api/model"

export const activeDirectDebitStates = new Set<DirectDebitState>([
  DirectDebitState.activeFixed,
  DirectDebitState.activeVariable,
  DirectDebitState.pendingActivation,
  DirectDebitState.failedPayment,
])
